import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LazyImage } from 'project/lazy-image';
import { generateBemCss } from 'general/js/helpers';
import { bemClasses } from './enums';

const CoutryFlag = ({ image, childCss, bemList, title }) => {
    const bemCss = generateBemCss('country-flag', bemList);
    const stateCss = classNames({
        'has-image': image
    });

    return (
        <div className={`${childCss} ${bemCss} ${stateCss}`}>
            <LazyImage image={image} title={title}/>
        </div>
    );
};

CoutryFlag.defaultProps = {
    bemList: [bemClasses.BASE],
    childCss: '',
    title: ''
};

CoutryFlag.propTypes = {
    image: PropTypes.string,
    bemList: PropTypes.array,
};

export default CoutryFlag;
